import React, { useState, forwardRef, useEffect } from "react";
import { Offcanvas } from "react-bootstrap";
import swal from "sweetalert";
import { MultiSelect } from "react-multi-select-component";
import { LiaDollarSignSolid } from "react-icons/lia";
import DatePicker from "react-datepicker";
import AdminCouponService from "../../../API/Services/AdminService/AdminCouponService";

const CouponOffcanvas = forwardRef((props, ref) => {
  const { canvasShowAdd, seCanvasShowAdd } = props;

  const [error, setError] = useState({});
  const [formData, setFormData] = useState({});
  const [filterQuery, setFilterQuery] = useState({});
  const [userDropDown, setUserDropDown] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [apiError, setApiError] = useState("");

  // const parseDate = (dateString) => {
  //   const [month, day, year] = dateString.split("/");
  //   return new Date(year, month - 1, day);
  // };
  const parseDate = (dateStr) => {
    if (!dateStr) return null;

    const [year, month, day] = dateStr.split("/").map(Number);

    return new Date(year, month - 1, day); // month is 0-based
  };

  useEffect(() => {
    if (canvasShowAdd) {
      GetEligibleUserList();
      setFormData({
        code: "",
        discount: "",
      });
      setFilterQuery({ from: "" });
      setSelectedUser([]);
      setError("");
    }
  }, [canvasShowAdd]);

  const GetEligibleUserList = async () => {
    try {
      const responseData = await AdminCouponService.get_users_list().json();
      const formattedData = responseData?.map((user) => ({
        label: `${user?.name} ${user?.last_name}`,
        value: user?.id,
      }));
      setUserDropDown(formattedData);
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
      }
    }
  };

  const handleSelectUserChange = (selectedItems) => {
    const items = Array.isArray(selectedItems) ? selectedItems : [];
    // const selectedNames = items.map((item) => item.value).join(", ");
    setSelectedUser(items);
    setError((prev) => ({
      ...prev,
      user_ids: "",
    }));
  };

  const handleFilterDateFrom = (date) => {
    if (date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      setFilterQuery((prev) => ({
        ...prev,
        from: `${year}/${month}/${day}`,
      }));

      setError((prev) => ({
        ...prev,
        valid_until: "",
      }));
    } else {
      setFilterQuery((prev) => ({
        ...prev,
        from: "",
      }));
    }
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   if (name == "code") {
  //     const code = (value = e.target.value
  //       .toUpperCase()
  //       .replace(/[^A-Z0-9]/g, ""));
  //     setFormData({ ...formData, [name]: code });
  //   }
  //   setFormData({ ...formData, [name]: value });
  // };
  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    if (name === "code") {
      updatedValue = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    }

    setFormData({
      ...formData,
      [name]: updatedValue,
    });

    setError((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // const handleSubmit = async (event) => {
  //   event.preventDefault();

  //   try {
  //     var userData = {
  //       title: formData?.code,
  //       value: formData.discount,
  //       valid_until: filterQuery?.from,
  //       user_ids: selectedUser.map((item) => item?.value),
  //     };

  //     const data = await AdminCouponService.store(userData).json();

  //     if (data) {
  //       swal("Coupon Created Successfully").then((willDelete) => {
  //         if (willDelete) {
  //           seCanvasShowAdd(false);
  //           props.parentCallback();
  //         }
  //       });
  //       setFormData({
  //         code: "",
  //         discount: "",
  //       });
  //       setFilterQuery({ from: "" });
  //       setSelectedUser([]);
  //     }else{
  //       console.log("error", data.errors.message)
  //     }
  //   } catch (error) {
  //     if (error.response?.status === 422) {
  //       console.log("error", error)
  //       const errorData = await error.response.json();
  //       setError({
  //         code: errorData?.errors?.title?.[0] || "",
  //         discount: errorData?.errors?.value?.[0] || "",
  //         valid_until: errorData?.errors?.valid_until?.[0] || "",
  //         user_ids: errorData?.errors?.user_ids?.[0] || "",
  //       });
  //       return;
  //     }
  //   }
  // };

  // const handleSelectMasterPlanChange = (selectedOption) => {
  //   setSelectedMasterPlan(selectedOption);
  // };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setApiError("");

    try {
      const userData = {
        title: formData?.code,
        value: formData.discount,
        valid_until: filterQuery?.from,
        user_ids: selectedUser.map((item) => item?.value),
      };

      const data = await AdminCouponService.store(userData).json();

      swal("Coupon Created Successfully").then((ok) => {
        if (ok) {
          seCanvasShowAdd(false);
          props.parentCallback();
        }
      });

      setFormData({ code: "", discount: "" });
      setFilterQuery({ from: "" });
      setSelectedUser([]);
      setError({});
    } catch (error) {
      // ky HTTPError
      if (error.name === "HTTPError" && error.response) {
        const errorData = await error.response.json().catch(() => ({}));

        // 422 validation errors
        if (error.response.status === 422) {
          setError({
            code: errorData?.errors?.title?.[0] || "",
            discount: errorData?.errors?.value?.[0] || "",
            valid_until: errorData?.errors?.valid_until?.[0] || "",
            user_ids: errorData?.errors?.user_ids?.[0] || "",
          });

          // if backend also sends a general message, show it
          setApiError(errorData?.message || errorData?.errors?.message || "");
          return;
        }

        // other HTTP errors (400/401/403/500 etc.)
        setApiError(
          errorData?.message ||
          errorData?.error ||
          errorData?.errors?.message ||
          `Request failed (HTTP ${error.response.status}).`
        );
        return;
      }

      // non-HTTP errors (network etc.)
      setApiError(error?.message || "Something went wrong. Please try again.");
    }
  };

  return (
    <>
      <Offcanvas
        show={canvasShowAdd}
        onHide={seCanvasShowAdd}
        className="offcanvas-end customeoff"
        placement="end"
      >
        <div className="offcanvas-header">
          <h5 className="modal-title" id="#gridSystemModal">
            {props.Title}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              seCanvasShowAdd(false);
              setFormData({
                code: "",
                discount: "",
              });
              setFilterQuery({ from: "" });
              setSelectedUser([]);
            }}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="container-fluid">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-xl-6 mb-3">
                  <label
                    htmlFor="exampleFormControlInput3"
                    className="form-label"
                  >
                    Coupon code <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="code"
                    value={formData.code}
                    onChange={handleChange}
                    className="form-control"
                    id="exampleFormControlInput3"
                    placeholder=""
                  />
                  {error.code && (
                    <p className="text-danger fs-12 mt-1">{error.code}</p>
                  )}
                </div>

                <div className="col-xl-6 mb-3">
                  <label
                    htmlFor="exampleFormControlInput5"
                    className="form-label"
                  >
                    Discount <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="number"
                      name="discount"
                      onChange={handleChange}
                      value={formData.discount}
                      className="form-control"
                      id="exampleFormControlInput7"
                      placeholder=""
                    />
                    <button
                      className="btn btn-outline-light"
                      type="button"
                      style={{ borderColor: "#cccccc" }}
                    >
                      <LiaDollarSignSolid />
                      {/* {type == "0" ? (
                        <AiOutlinePercentage />
                      ) : (
                        <LiaDollarSignSolid />
                      )} */}

                      {/* {showNewPassword ? <FiEye /> : <FiEyeOff />} */}
                    </button>
                  </div>
                  {error.discount && (
                    <p className="text-danger fs-12 mt-1">{error.discount}</p>
                  )}
                </div>

                <div className="col-xl-6 mb-3">
                  <label className="form-label">
                    Expiry Date: <span className="text-danger">*</span>
                  </label>
                  <DatePicker
                    name="from"
                    className="form-control"
                    selected={
                      filterQuery.from ? parseDate(filterQuery.from) : null
                    }
                    onChange={handleFilterDateFrom}
                    // dateFormat="yyyy/dd/MM"
                    dateFormat="MM/dd/yyyy"
                    placeholderText="mm/dd/yyyy"
                    // minDate={new Date()}
                    minDate={
                      new Date(new Date().setDate(new Date().getDate() + 1))
                    }
                  />
                  {error.valid_until && (
                    <p className="text-danger fs-12 mt-1">
                      {error.valid_until}
                    </p>
                  )}
                </div>

                <div className="col-xl-6 mb-3">
                  <label className="form-label">
                    User: <span className="text-danger">*</span>
                    <div className="btn-tooltip" id="area">
                      {/* <IoMdInformationCircleOutline height={50} width={50} /> */}
                      {/* <Tooltip
                        anchorSelect="#area"
                        style={{ zIndex: 999 }}
                        clickable={true}
                        content={
                          <>
                            See our Sub-Market
                            <br /> Area Map:{" "}
                            <a
                              href="https://www.homebuildersresearch.com/images/misc/sub_market_areas.png"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View Map
                            </a>
                          </>
                        }
                      /> */}
                    </div>
                  </label>
                  <MultiSelect
                    name="user"
                    options={userDropDown}
                    value={selectedUser}
                    onChange={handleSelectUserChange}
                    placeholder="Select User"
                  />
                  {error.user_ids && (
                    <p className="text-danger fs-12 mt-1">{error.user_ids}</p>
                  )}
                </div>
                {apiError && <p className="text-danger fs-12 mt-2">{apiError}</p>}
              </div>
              <div>
                <button type="submit" className="btn btn-primary me-1">
                  Submit
                </button>
                <button
                  type="button"
                  onClick={() => {
                    seCanvasShowAdd(false);
                    seCanvasShowAdd(false);
                    setFormData({
                      code: "",
                      discount: "",
                    });
                    setFilterQuery({ from: "" });
                    setSelectedUser([]);
                  }}
                  className="btn btn-danger light ms-1"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </Offcanvas>
    </>
  );
});

export default CouponOffcanvas;
